import emitter from "tiny-emitter/instance";

export const eventBus = {
  $on: (...args) => emitter.on(...args),
  $once: (...args) => emitter.once(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};

export const events = {
  OPEN_SHEET_PROMOTION: "OPEN_SHEET_PROMOTION",
  OPEN_SHEET_SHOP: "OPEN_SHEET_SHOP",
  OPEN_SHEET_SHOP_FILTERS: "OPEN_SHEET_SHOP_FILTERS",
  OPEN_SHEET_SHOP_SORTING: "OPEN_SHEET_SHOP_SORTING",
};
